const postpaidServicesStyle = () => ({
	logoWrapper: {
		'& img': {
			width: '65px',
			height: 'auto',
		},
	},
	container: {
		margin: '0px',
	},
	header: {
		margin: 16,
		display: 'flex',
		'justify-content': 'space-between',
		'align-items': 'center',
		'& button': {
			'min-width': '0',
		},
	},
	headingWrapper: {
		display: 'flex',
		'align-items': 'center',
		marginLeft: 16,
		marginRight: 16,
		marginBottom: 25,
		marginTop: 24,
	},
	inlineIcon: {
		height: 16,
		width: 16,
		objectFit: 'cover',
		marginRight: 8,
	},
	boxStyle: {
		display: 'flex',
		flexWrap: 'nowrap',
		'scrollbar-width': 'none',
		'-ms-overflow-style': 'none',
		overflowX: 'auto',
		'padding-left': '12px',
		'padding-right': '12px',
		'& > :not(style)': {
			flex: '0 0 auto',
			width: 160,
			'min-height': 128,
			margin: '0px 8px 12px 6px;',
		},
		'&::-webkit-scrollbar': {
			display: 'none',
		},
	},
	paperStyle: {
		'margin-left': '15px',
		'margin-right': '5px',
		borderRadius: 8,
		cursor: 'pointer',
	},
	icon: {
		height: 40,
		width: 40,
		filter: 'opacity(0.65)',
	},
	iconContainer: {
		margin: '16px auto 16px 16px',
		textAlign: 'left',
	},
	textWrapper: {
		margin: '0 16px 16px',
		'max-width': '128px',
		overflow: 'hidden',
		'text-overflow': 'ellipsis',
		display: '-webkit-box',
		'-webkit-line-clamp': 4,
		'-webkit-box-orient': 'vertical',
	},
	linkWrapper: {
		margin: '0 16px',
		textAlign: 'right',
	},
	categoryWrapper: {
		margin: 0,
		'& > p': {
			margin: '12px 16px 12px 16px',
			color: 'rgba(0, 0, 0, 0.54)',
			letterSpacing: '1.26px',
		},
	},
});

export default postpaidServicesStyle;
